import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

const initialMSMEs = [
  { name: 'Aarav Textiles', place: 'Surat', score: 94 },
  { name: 'Sarthak Engineering', place: 'Pune', score: 92 },
  { name: 'Unity AgroTech', place: 'Nagpur', score: 90 },
  { name: 'GreenWave Biotech', place: 'Chandigarh', score: 89 },
  { name: 'Luminous Logistics', place: 'Hyderabad', score: 87 },
  { name: 'NeoAuto Components', place: 'Coimbatore', score: 86 },
  { name: 'Precision Pipes', place: 'Rajkot', score: 85 },
  { name: 'Shree Foods Pvt Ltd', place: 'Indore', score: 84 },
  { name: 'BlueOrbit Tech', place: 'Bengaluru', score: 83 },
  { name: 'Crystal Chemicals', place: 'Vadodara', score: 82 },
  { name: 'Sunrise Plastics', place: 'Aurangabad', score: 91 },
  { name: 'EcoTech Solutions', place: 'Jaipur', score: 88 },
  { name: 'IronClad Components', place: 'Jamshedpur', score: 85 },
  { name: 'AquaPure Systems', place: 'Bhopal', score: 83 },
  { name: 'Rapid Packaging', place: 'Lucknow', score: 80 }
];

const ScrappyScorecard = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [selectedRole, setSelectedRole] = useState('Student');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/matrika");
  };

  // Dynamic rankings state
  const [rankings, setRankings] = useState([]);

  // Shuffle helper
  const shuffleAndSelectTop10 = () => {
    const shuffled = [...initialMSMEs]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((msme, index) => ({ rank: index + 1, ...msme }));
    setRankings(shuffled);
  };

  useEffect(() => {
    shuffleAndSelectTop10(); // Initial load
    const interval = setInterval(shuffleAndSelectTop10, 5000);
    return () => clearInterval(interval); // Cleanup
  }, []);

  const today = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  });

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-800 bg-gradient-to-br from-blue-400 to-blue-600">

      {/* HEADER */}
      <header className="flex justify-between items-center px-6 py-4 bg-blue-700 shadow-md sticky top-0 z-50">
        <div
          onClick={() => navigate('/rankings')}
          className="text-3xl font-extrabold text-white tracking-wide cursor-pointer"
        >
          Sharm Samman Rankings
        </div>
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">Welcome, {userName}</span>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-xl text-white bg-blue-500 px-3 py-1 rounded"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-blue-400 flex flex-col px-6 py-4 space-y-3">
          {isLoggedIn && (
            <div className="mt-4 border-t pt-3 border-white text-white">
              <p className="mb-2">Welcome, {userName}</p>
              <button
                onClick={handleLogout}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      {/* MAIN CONTENT */}
      <main className="flex-1 bg-gray-500 text-gray-900 p-4 md:p-8">
        <div className="text-center mb-6">
          <p className="text-white">{today}</p>
        </div>

        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="min-w-full table-auto border border-gray-300">
            <thead className="bg-blue-100 text-blue-800">
              <tr>
                <th className="py-2 px-1 border">Rank</th>
                <th className="py-2 px-4 border">BlueHand Name</th>
                <th className="py-2 px-4 border">Place</th>
                <th className="py-2 px-1 border">Score</th>
              </tr>
            </thead>
            <tbody className="bg-blue-700 transition-all duration-500">
              {rankings.map(({ rank, name, place, score }) => (
                <tr key={name} className="text-left hover:bg-blue-800 transition-all">
                  <td className="py-2 px-1 border">{rank}</td>
                  <td className="py-2 px-4 border">{name}</td>
                  <td className="py-2 px-4 border">{place}</td>
                  <td className="py-2 px-1 border font-semibold text-white">{score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* FOOTER */}
      <footer className="bg-blue-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ScrappyScorecard;
